import React from 'react';

var d = 'M0 7h7v-7h2v7h7v2h-7v7h-2v-7h-7';

module.exports = (props) => (
  <svg
    style={props.style}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMinYMin"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path d={d} />
  </svg>
);
